module.exports = __webpack_public_path__ + "static/media/circleCross16.a1d1e0d6.svg";